import { useMemo } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireAnalyticsEvent } from '@atlaskit/editor-common/analytics';
export function useFireAnalyticsEvent() {
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  return useMemo(function () {
    return fireAnalyticsEvent(createAnalyticsEvent);
  }, [createAnalyticsEvent]);
}